// import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting.ts';
import { statusTransitionQueryResponseType } from '@/modules/FileDetail/queries/statusTransition/statusTransitionQuery.type.ts';

export const statusTransitionFunction = ({
  id,
  // page = 1,
}: {
  id: string;
  // page?: number | undefined;
}): Promise<statusTransitionQueryResponseType[]> =>
  fetchApi.get(`file_status/${id}/file_status_log/`);
